import { render, staticRenderFns } from "./m-document-saved-participants-route-form.vue?vue&type=template&id=2c1eed4e&scoped=true&lang=pug"
import script from "./m-document-saved-participants-route-form.vue?vue&type=script&lang=js"
export * from "./m-document-saved-participants-route-form.vue?vue&type=script&lang=js"
import style0 from "./m-document-saved-participants-route-form.vue?vue&type=style&index=0&id=2c1eed4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1eed4e",
  null
  
)

export default component.exports